import React, { BaseSyntheticEvent } from 'react'
import { TextInputWithLabel } from '@/src/common/components/elements/Forms/TextInputWithLabel'
import { inputHasError } from '@/src/common/utilities/inputHasError'
import { FormErrorDisplay } from '@/src/modules/build-a-card/FormErrorDisplay'
import { ValidationError } from 'yup'
import { clearFormErrorForField } from '@/src/common/utilities/clearFormErrorForField'
import { THandleListUpdate } from '@/src/modules/build-a-card/inputs/types'
import { handleRecipientChange } from '@/src/modules/build-a-card/utilities/handleRecipientChange'

const PhoneNumberInput = ({
    phone,
    setPhone,
    formErrors,
    setFormErrors,
    fieldId,
    handleList,
    placeholder,
    label = 'Phone number',
    isRequired = false,
    inputStyle,
}: {
    phone: string
    setPhone: Function
    formErrors: ValidationError[]
    setFormErrors: Function
    fieldId: string
    label?: string
    placeholder?: string
    handleList?: THandleListUpdate
    isRequired?: boolean
    inputStyle?: 'stripe'
}) => {
    const labelText: string =
        phone.length || isRequired || inputStyle === 'stripe' ? label : ''

    return (
        <div key={fieldId}>
            <TextInputWithLabel
                isRequired={isRequired}
                id={fieldId}
                placeholder={placeholder ?? label}
                label={labelText}
                numFormat={'(###) ###-####'}
                value={phone}
                autoComplete={'tel-local'}
                onChange={(e: BaseSyntheticEvent) => {
                    if (handleList) {
                        handleRecipientChange({ ...handleList, e: e })
                    } else {
                        let trimmedValue = e.currentTarget.value.trim()
                        setPhone(trimmedValue)
                    }

                    clearFormErrorForField({
                        path: fieldId,
                        formErrors: formErrors,
                        setFormErrors: setFormErrors,
                    })
                }}
                hasError={inputHasError(formErrors, fieldId)}
                data-testid={'phone-number'}
                inputStyle={inputStyle}
            />
            <FormErrorDisplay
                formErrors={formErrors}
                path={fieldId}
                className={inputStyle}
            />
        </div>
    )
}

export default PhoneNumberInput
